export const ruTranslations = {
    page: {
        learning: 'Моё обучение',
        tournament: 'Турнир',
        tournaments: 'Турниры',
        settings: 'Настройки пользователя',
        termsConditions: 'Правила и условия',
        notifications: 'Уведомления',
        help: 'Помощь',
        assignments: 'Задания',
        performance: 'Производительность',
        management: 'Управление',
        managementUsers: 'Профили пользователей',
        managementGroups: 'Группы пользователей',
    },
    menu: {
        buttons: {
            product: 'Страница продукта',
        },
    },
    footer: {
        copyright: '© 2025 RoadMaster VR. Все права защищены.',
    },
    common: {
        loading: 'Загрузка',
        daysAbbr: 'д.',
        hoursAbbr: 'ч',
        minutesAbbr: 'мин',
        status: {
            notStarted: 'Не начато',
            inProgress: 'В процессе',
            progress: 'В процессе',
            completed: 'Завершено',
            passed: 'Пройдено',
            failed: 'Не пройдено',
            running: 'Запущено',
            active: 'Активно',
            inactive: 'Неактивно',
            draft: 'Черновик',
            ready: 'Готов',
            offline: 'Не в сети',
            starting: 'Запуск',
            stopped: 'Остановлено',
            started: 'Запущено',
            required: 'Обязательно',
            optional: 'Опционально',
        },
    },
    title: {
        courseDetail: 'Детали курса RoadMaster VR',
        learnings: 'Обучение RoadMaster VR',
        settings: 'Настройки RoadMaster VR',
        main: 'Платформа RoadMaster VR',
        login: 'Вход RoadMaster VR',
        reset: 'Сброс RoadMaster VR',
        changePassword: 'Смена пароля RoadMaster VR',
        tournaments: 'RoadMaster VR Турниры',
        tournament: 'RoadMaster VR Tурнир',
        error: 'RoadMaster VR Ошибка',
        assignments: 'RoadMaster VR Задания',
    },
    error: {
        userLearningsTitle: 'Ошибка загрузки обучения',
        userPasswordTitle: 'Ошибка пароля пользователя',
        userSettingsTitle: 'Ошибка настроек пользователя',
        loginTitle: 'Ошибка входа',
        logoutTitle: 'Ошибка выхода',
        baseInfoTitle: 'Ошибка основной информации',
        resetTitle: 'Ошибка сброса',
        changePasswordTitle: 'Ошибка смены пароля',
        missingTokenTitle: 'Отсутствует токен сброса',
        missingTokenMessage: 'Токен сброса не предоставлен',
        missingUsernameTitle: 'Отсутствует имя пользователя',
        missingUsernameMessage: 'Имя пользователя не предоставлено',
        missingProgramId: 'Идентификатор программы отсутствует',
        missingLessonId: 'Идентификатор урока отсутствует',
        serverError: 'Ошибка сервера',
    },
    success: {
        check: 'Действительно',
        userSettingsTitle: 'Успешно',
        userPasswordTitle: 'Успешно',
    },
    launcherUpdate: {
        title: 'Требуется обновление лаунчера симулятора.',
        message:
            'Перезапустите лаунчер RoadMaster (или компьютер) на: {{computers}}. После этого версия {{version}} установится автоматически.',
        badge: 'Нужно обновление',
    },
    pagination: {
        goTo: 'Перейти на страницу',
        previous: 'Назад',
        next: 'Далее',
        submit: 'Отправить',
        of: 'из',
        rowsPerPage: 'Строк на странице',
    },
    tournamentsPage: {
        title: 'Турниры',
        emptyState: 'Турниры не созданы. Если вам нужен турнир, обратитесь в техническую поддержку.',
        headers: {
            name: 'Турнир',
            status: 'Статус',
            participants: 'Участники',
            statsAt: 'Начинается',
            endsAt: 'Заканчивается',
            actions: 'Действия',
        },
    },
    assignmentCrudPage: {
        basicInfo: 'Основная информация',
        titleCreate: 'Создать новое задание',
        titleEdit: 'Редактировать задание',
        or: 'или',
        selectedUsers: 'Выбор пользователей',
        selectedOnly: 'Только отмеченные',
        selectedContent: 'Выбор материалов',
        usersSelected: 'Выбранные пользователи',
        contentSelected: 'Выбранные материалы',
        filters: {
            searchBy: 'Поиск по',
            programs: 'Программы',
            courses: 'Курсы',
            tags: 'Метки',
            show: 'Показать',
            selected_only: 'Только отмеченные',
            findProgramsCourses: 'Поиск программ и курсов',
            findUsers: 'Поиск пользователей или групп',
            findProgramsCoursesPlaceholder: 'Поиск по имени или метке',
            findUsersPlaceholder: 'Поиск по имени или названию группы',
            Days: 'День',
            Weeks: 'Неделя',
            Months: 'Месяц',
        },
        modal: {
            titleDiscard: 'Вы уверены, что хотите удалить черновик задания?',
            textDiscard: 'После деактивации задания повторная активация будет невозможна.',
            titleDraft: 'Вы уверены, что хотите сохранить как черновик?',
            textDraft: 'Будет создан новый черновик задания.',
            titlePublish: 'Вы уверены, что хотите сохранить и опубликовать?',
            textPublish: 'Назначенные пользователи и группы получат доступ к заданию.',
            titleDeactivate: 'Вы уверены, что хотите деактивировать задание?',
            textDeactivate: 'После деактивации будут отображаться со статусом «Неактивно».',
            titleBack: 'Вы уверены, что хотите вернуться к заданиям? ',
            buttons: {
                cancel: 'Отмена',
                discard: 'Удалить',
                deactivate: 'Деактивировать',
                saveDraft: 'Сохранить черновик',
                savePublish: 'Сохранить и опубликовать',
                back: 'Список заданий',
            },
        },
        buttons: {
            discard: 'Удалить',
            save: 'Сохранить и опубликовать',
            saveDraft: 'Сохранить черновик',
            deactivate: 'Деактивировать',
            savePublish: 'Сохранить и опубликовать',
            back: 'Назад к заданиям',
            edit: 'Редактировать',
            cancel: 'Отмена',
        },
        labels: {
            name: 'Название задания',
            type: 'Тип задания',
            dueDate: 'Дата завершения: до',
            duration: 'Период доступности',
            requiredAssignment: 'Обязательное задание',
            timeFrame: 'Временной период',
        },
        headers: {
            userName: 'Имя',
            email: 'Эл. почта',
            assignmentName: 'Название',
            tags: 'Метки',
            createdBy: 'Автор',
            createdAt: 'Дата создания',
            type: 'Тип',
        },
    },
    assignmentsPage: {
        buttons: {
            create: 'Создать задание',
        },
        filters: {
            assignmentName: 'Поиск заданий',
            type: 'Тип',
            status: 'Статус',
            placeholder: 'Поиск',
            all: 'Все',
        },
        headers: {
            assignmentName: 'Название задания',
            type: 'Тип',
            status: 'Статус',
            learners: 'Ученики',
            createdBy: 'Автор',
            createdAt: 'Дата создания',
            duaDate: 'Дата завершения: до',
            actions: 'Действия',
        },
        tooltips: {
            edit: 'Редактировать',
            assignmentDetails: 'Детали задания',
            performance: 'Производительность',
        },
        title: 'Задания',
        subTitle: 'Задания',
    },
    assignmentManagePage: {
        headers: {
            computer: 'Компьютер',
            status: 'Статус',
            driver: 'Водитель',
            lesson: 'Урок',
            type: 'Тип',
            mode: 'Режим',
            actions: 'Действия',
            totalScore: 'Общий балл',
            attempt: 'Попытка',
            simulator: 'Симулятор',
        },
        driverRow: {
            driverName: 'Имя водителя',
            internalId: 'Внутренний ID',
            country: 'Страна',
            completionRate: 'Процент выполнения',
            completion: 'Выполнение',
        },
        buttons: {
            stop: 'Стоп',
            view: 'Просмотр',
            run: 'Запуск',
            starting: 'Запуск...',
        },
        actions: {
            expandAll: 'Развернуть все',
            collapseAll: 'Свернуть все',
        },
        search: {
            placeholder: 'Поиск водителей по имени, ID или стране...',
        },
        simulator: {
            selectSimulator: 'Выберите симулятор',
        },
        status: {
            notStarted: 'Не начато',
            completed: 'Завершено',
            inProgress: 'В процессе',
            running: 'Запущено',
        },
        sort: {
            sortBy: 'Сортировать по',
            sortDriversBy: 'Сортировать водителей по',
            default: 'По умолчанию',
            completionDesc: 'Выполнение % (высокое → низкое)',
            completionAsc: 'Выполнение % (низкое → высокое)',
            avgScoreDesc: 'Средний балл (высокий → низкий)',
            avgScoreAsc: 'Средний балл (низкий → высокий)',
            statusProgress: 'Сначала в процессе',
            statusNotStarted: 'Сначала не начатые',
            statusCompleted: 'Сначала завершенные',
            attemptsDesc: 'Больше всего попыток',
            attemptsAsc: 'Меньше всего попыток',
        },
        modals: {
            notes: {
                title: 'Добавить заметку инструктора',
                subtitle: 'Добавить заметку для',
                placeholder: 'Введите заметку здесь...',
                cancel: 'Отмена',
                save: 'Сохранить заметку',
            },
            config: {
                title: 'Расширенные настройки',
                simulationType: 'Тип симуляции (тип устройства)',
                lessonLanguage: 'Язык урока',
                aiTraffic: 'ИИ трафик',
                timeOfDay: 'Время суток',
                weather: 'Погода',
                vrTutorial: 'VR обучение',
                lessonDefault: 'По умолчанию',
                vr: 'VR',
                screen: 'Экран',
                yes: 'Да',
                no: 'Нет',
                day: 'День',
                night: 'Ночь',
                clear: 'Ясно',
                rain: 'Дождь',
                storm: 'Шторм',
                cancel: 'Отмена',
                save: 'Сохранить',
                languages: {
                    eng: 'ENG',
                    lt: 'LT',
                    ru: 'RU',
                },
            },
            computerStatus: {
                component: 'Компонент',
                status: 'Статус',
                notes: 'Заметки',
                lastOnline: 'Последнее подключение',
                refreshing: 'Обновление',
                refresh: 'Обновить',
                close: 'Закрыть',
            },
            statusChange: {
                title: 'Изменить статус урока',
                message:
                    'Изменить статус {{driver}} - {{lesson}} на «{{status}}»? Это повлияет на статистику выполнения.',
                confirm: 'Изменить статус',
                cancel: 'Отмена',
            },
        },
        errors: {
            createLessonAttemptFailed: 'Не удалось запустить урок. Попробуйте снова.',
            updateLessonAttemptStatusFailed: 'Не удалось обновить статус урока. Попробуйте снова.',
        },
    },
    performancePage: {
        title: 'Производительность уроков водителей',
        export: 'Экспорт',
        filters: {
            team: 'Команда',
            content: 'Контент',
            totalScore: 'Общий балл',
            date: 'Дата',
            allDrivers: 'Все водители',
            byDriver: 'По водителю',
            byGroup: 'По группе',
            search: 'Поиск',
            noGroupsAvailable: 'Группы не доступны',
            allContent: 'Весь контент',
            byLesson: 'По уроку',
            byAssignment: 'По заданию',
            lessons: 'Уроки',
            assignments: 'Задания',
            allLessons: 'Все уроки',
            lastAttempt: 'Последняя попытка',
            onlyExams: 'Только экзамены',
            clear: 'Очистить',
            apply: 'Применить',
            last1Month: 'Последний месяц',
            last2Months: 'Последние 2 месяца',
            last3Months: 'Последние 3 месяца',
            last6Months: 'Последние 6 месяцев',
            last12Months: 'Последние 12 месяцев',
            timeFrame: 'Временной период',
        },
        kpi: {
            driversEnrolled: 'Зарегистрировано водителей',
            avgTimeSpent: 'Среднее время обучения',
            avgScore: 'Средний балл',
            completionRate: 'Процент завершения',
            kpi: 'KPI',
            kpis: 'KPI',
        },
        table: {
            lesson: 'Урок',
            type: 'Тип',
            mode: 'Режим',
            status: 'Статус',
            totalScore: 'Общий балл',
            startDate: 'Дата/время начала',
            sessionDuration: 'Длительность сессии',
            attempt: 'Попытка',
            details: 'Детали',
        },
        driverRow: {
            internalId: 'Внутренний ID',
            country: 'Страна',
            completionRate: 'Процент завершения',
            completion: 'Завершение',
        },
        actions: {
            expandAll: 'Развернуть все',
            collapseAll: 'Свернуть все',
        },
        search: {
            placeholder: 'Поиск водителей по имени, ID или стране...',
        },
        status: {
            notStarted: 'Не начато',
            completed: 'Завершено',
            inProgress: 'В процессе',
            progress: 'В процессе',
            running: 'Запущено',
            passed: 'Завершено',
            failed: 'Не пройдено',
        },
        sort: {
            sortBy: 'Сортировать по',
            sortDriversBy: 'Сортировать водителей по',
            default: 'По умолчанию',
            completionDesc: 'Завершение % (высокое к низкому)',
            completionAsc: 'Завершение % (низкое к высокому)',
            avgScoreDesc: 'Средний балл (высокий к низкому)',
            avgScoreAsc: 'Средний балл (низкий к высокому)',
            statusProgress: 'Сначала в процессе',
            statusNotStarted: 'Сначала не начатые',
            statusCompleted: 'Сначала завершенные',
            attemptsDesc: 'Больше всего попыток',
            attemptsAsc: 'Меньше всего попыток',
        },
        selection: {
            of: 'из',
            drivers: 'водителей',
        },
        details: {
            driverName: 'Имя водителя',
            internalId: 'Внутренний ID',
            country: 'Страна',
            completionRate: 'Процент завершения',
            startDate: 'Дата начала',
            startDateTime: 'Дата/время начала',
            generalInfo: 'Общая информация',
        },
        metrics: {
            results: 'Результаты',
            yourResult: 'Ваш результат',
            goal: 'Цель',
        },
        emptyState: {
            title: 'Нет данных',
            message:
                'Не найдено данных о производительности для выбранных фильтров. Попробуйте изменить фильтры, чтобы увидеть результаты.',
        },
    },
    error404Page: {
        title: 'Страница не найдена!',
        subTitle: 'ОШИБКА: 404',
        text: 'Запрашиваемый URL не существует.',
    },
    error500Page: {
        title: 'Внутренняя ошибка сервера',
        subTitle: 'ОШИБКА: 500',
        text: 'Сервер столкнулся с внутренней ошибкой или неправильной конфигурацией и не смог выполнить ваш запрос.',
    },
    tournamentPage: {
        leaderboard: 'Таблица лидеров',
        join: 'Присоединиться',
        tournament: 'к турниру!',
        emptyState: 'Турниры не созданы. Если вам нужен турнир, обратитесь в техническую поддержку.',
        form: {
            playerName: 'Имя участника',
            computer: 'Компьютер',
            start: 'Старт',
            stop: 'Стоп',
        },
        banner: {
            total: 'ВСЕГО',
            drivers: 'ВОДИТЕЛЕЙ',
            tournament: 'ТУРНИР',
            ends: 'ЗАВЕРШАЕТСЯ',
            time: 'ВРЕМЯ',
            left: 'ОСТАЛОСЬ',
            hours: 'Часов',
            minutes: 'Минут',
            seconds: 'Секунд',
            winners: 'Таблица лидеров',
        },
        session: {
            totalScore: 'ОБЩИЙ СЧЕТ',
            speedingFine: 'ШТРАФ ЗА ПРЕВЫШЕНИЕ СКОРОСТИ',
            time: 'ВРЕМЯ',
            conesHit: 'СБИТЫЕ КОНУСЫ',
        },
    },
    courseDetailPage: {
        buttons: {
            start: 'Начать',
            continue: 'Продолжить',
            retake: 'Пересдать',
            next: 'Далее',
            submit: 'Сдать',
            terminate: 'Прекратить урок',
        },
        modal: {
            titleDiscard: 'Вы уверены, что хотите прервать этот урок?',
            textDiscard: 'Если продолжите, ваш прогресс будет потерян.',
            buttons: {
                cancel: 'Отменить',
                discard: 'Вернуться к уроку',
            },
        },
        popover: {
            launch: 'Начать',
            form: {
                computer: 'Выбрать симулятор',
                start: 'Начать',
                stop: 'Отмена',
            },
        },
        keyKpis: {
            title: 'Основные показатели урока',
        },
        kpis: {
            score: 'Оценка',
            goal: 'Цель',
        },
        yourResult: 'Ваш результат',
        status: {
            notStarted: 'Не начато',
            progress: 'В процессе',
            passed: 'Пройдено',
            failed: 'Не пройдено',
            running: 'Запущено',
        },
        nonKeyKpis: {
            title: 'Обзор',
        },
        quizResults: {
            thanks: 'Спасибо!',
            completed: 'Тест завершён',
        },
        surveyResults: {
            thanks: 'Спасибо!',
            completed: 'Опрос завершён.',
        },
        type: 'Тип',
        yourAnswer: 'Ваш ответ',
        submitInfo: 'Осталось вопросов',
        menu: 'Меню уроков',
        question: 'Вопрос',
        description: 'Описание урока',
        contentDescription: 'Чтобы открыть содержание, начните урок',
        content: 'Содержание',
        collapse: 'Стрелка вниз',
        expand: 'Стрелка вверх',
        assigned: 'НАЗНАЧЕНО',
        dueby: 'СРОК ДО',
        completed: 'ЗАВЕРШЕНО',
        completedIn: 'ЗАВЕРШЕНО ЗА',
        started: 'НАЧАТО',
        duration: 'ДЛИТЕЛЬНОСТЬ',
        hour: 'ч',
        min: 'мин',
        sec: 'cек',
        lesson: 'Урок',
        drop: 'Перетащите ответ сюда',
        parkingPosition: 'Позиция парковки',
    },
    learningsPage: {
        emptyState: 'Нет назначенных уроков',
        meta: {
            finishedTotal: 'Завершено / Всего программ',
            coursesLessons: 'Курсов / Уроков осталось для завершения',
            deadline: 'Ближайший срок',
        },
        data: {
            program: {
                title: 'ПРОГРАММА',
                collapse: 'Стрелка вниз',
                expand: 'Стрелка вверх',
                course: 'КУРС',
            },
            course: {
                buttons: {
                    start: 'Начать',
                    continue: 'Продолжить',
                    starting: 'Запуск...',
                },
                collapse: 'Стрелка вниз',
                expand: 'Стрелка вверх',
                assigned: 'НАЗНАЧЕНО',
                dueby: 'СРОК ДО',
            },
            lesson: {
                lesson: 'Урок',
                locked: 'Закрыт',
                completed: 'Завершён',
            },
            overview: {
                buttons: {
                    more: 'Читать далее',
                    less: 'Скрыть',
                },
                lessonsLeft: 'УРОКОВ ВЫПОЛНЕНО',
                dueby: 'СРОК ДО',
                assigned: 'НАЗНАЧЕНО',
                duration: 'ДЛИТЕЛЬНОСТЬ',
            },
        },
        title: 'Мои обучения',
    },
    settingsPage: {
        buttons: {
            save: 'Сохранить',
            update: 'Обновить пароль',
            cancel: 'Отмена',
        },
        labels: {
            name: 'Имя',
            phoneNumber: 'Телефон',
            jobRole: 'Должность',
            surname: 'Фамилия',
            company: 'Компания',
            cardNumber: 'Номер карты тахографа',
            email: 'Электронная почта',
            password: 'Пароль',
            lastUpdated: 'Последнее обновление',
            changePassword: 'Изменить пароль',
            selectLanguage: 'Выбрать язык',
        },
        info: 'Для изменения данных обратитесь к своему инструктору.',
        form: {
            reminders: 'Напоминания',
            marketingMessages: 'Маркетинговые сообщения',
            language: 'Язык',
            oldPassword: 'Старый пароль',
            newPassword: 'Новый пароль',
            confirmNewPassword: 'Подтвердить новый пароль',
            passwordError: 'Введённые пароли не совпадают',
        },
        title: 'Настройки пользователя',
    },
    loginPage: {
        buttons: {
            contact: 'Свяжитесь с нами',
            login: 'Войти',
        },
        form: {
            email: 'Электронная почта',
            emailError: 'Пожалуйста, введите корректный адрес электронной почты',
            password: 'Пароль',
            forgotPassword: 'Забыли пароль',
            rememberMe: 'Запомнить меня',
        },
        title: 'Вход в систему управления обучением',
        subtitle: 'Ещё не зарегистрированы?',
    },
    resetPage: {
        buttons: {
            back: 'Назад к экрану входа',
            reset: 'Получить ссылку для восстановления',
        },
        form: {
            email: 'Введите корректный e-mail',
            emailError: 'Пожалуйста, введите корректный адрес электронной почты',
        },
        title: 'Сброс пароля',
    },
    changePasswordPage: {
        buttons: {
            back: 'Назад к экрану входа',
            change: 'Изменить',
        },
        form: {
            password: 'Введите новый пароль',
            repeatPassword: 'Повторите пароль',
            passwordError: 'Введённые пароли не совпадают',
        },
        title: 'Изменить пароль',
    },
    userProfiles: {
        headers: {
            lmsId: 'LMS ID',
            email: 'Эл. почта',
            firstName: 'Имя',
            lastName: 'Фамилия',
            employeeId: 'ID сотрудника',
            registrationDate: 'Дата регистрации',
            status: 'Статус',
            actions: 'Действия',
        },
        search: {
            placeholder: 'Поиск по эл. почте, имени или ID сотрудника...',
        },
        tooltips: {
            edit: 'Редактировать',
            deactivate: 'Деактивировать',
            activate: 'Активировать',
            remove: 'Удалить из интерфейса',
        },
        errors: {
            removeFailed: 'Не удалось удалить пользователя. Попробуйте снова.',
            toggleFailed: 'Не удалось изменить статус пользователя. Попробуйте снова.',
            loadFailed: 'Не удалось загрузить пользователей. Попробуйте снова.',
            updateFailed: 'Не удалось обновить данные пользователя. Попробуйте снова.',
        },
        modals: {
            removeUser: {
                title: 'Удалить пользователя из системы?',
                message:
                    'Это действие удалит пользователя из всех видимых списков LMS. Пользователь больше не будет доступен для новых назначений.',
                cancel: 'Отмена',
                confirm: 'Удалить',
            },
        },
        createUser: 'Создать пользователя',
    },
    editUser: {
        title: 'Обновить пользователя',
        lmsId: 'LMS ID',
        email: 'Эл. почта',
        firstName: 'Имя',
        lastName: 'Фамилия',
        employeeId: 'ID сотрудника',
        company: 'Компания',
        registrationDate: 'Дата регистрации',
        language: 'Язык',
        status: 'Статус',
        active: 'Активен',
        inactive: 'Неактивен',
        newPassword: 'Новый пароль',
        newPasswordHelper: 'Оставьте пустым, чтобы сохранить текущий',
        userGroups: 'Группы пользователей',
        groupsDisclaimer:
            'Членство в группе определяет участие в будущих назначениях. Существующие назначения не затрагиваются.',
        save: 'Сохранить',
        discard: 'Отменить',
        sendReset: 'Отправить письмо для сброса пароля',
        updateSuccess: 'Данные пользователя успешно обновлены',
        resetSent: 'Письмо для сброса пароля отправлено',
        requiredFieldsError: 'Пожалуйста, заполните все обязательные поля.',
        english: 'Английский',
        lithuanian: 'Литовский',
        russian: 'Русский',
    },
    userGroups: {
        headers: {
            groupId: 'ID группы',
            name: 'Название',
            description: 'Описание',
            userCount: 'Пользователи',
        },
        emptyState: 'Группы ещё не созданы',
        createGroup: 'Создать группу',
        search: 'Поиск групп...',
        tooltips: {
            edit: 'Редактировать группу',
            remove: 'Удалить группу',
            removeDisabled:
                'Группу нельзя удалить, пока в ней есть пользователи. Сначала удалите всех пользователей из группы.',
        },
        modals: {
            removeGroup: {
                title: 'Удалить группу?',
                message:
                    'Это действие удалит группу из активного использования в LMS. Назначенные в группу пользователи не будут удалены. Исторические данные, связанные с прошлыми назначениями и результатами, останутся без изменений.',
                confirm: 'Удалить',
                cancel: 'Отмена',
            },
        },
        errors: {
            removeFailed: 'Не удалось удалить группу. Попробуйте снова.',
        },
        success: {
            removed: 'Группа успешно удалена',
        },
    },
    createGroup: {
        title: 'Создать группу',
        groupName: 'Название группы',
        description: 'Описание',
        create: 'Создать',
        discard: 'Отменить',
        users: {
            title: 'Назначить пользователей',
            searchPlaceholder: 'Поиск по имени, фамилии или ID сотрудника...',
            add: 'Добавить',
            remove: 'Удалить {{name}}',
            addedTitle: 'Назначенные пользователи',
            columns: {
                name: 'Имя',
                email: 'Эл. почта',
                employeeId: 'ID сотрудника',
            },
        },
        success: {
            created: 'Группа успешно создана',
        },
        errors: {
            nameRequired: 'Название группы обязательно.',
            createFailed: 'Не удалось создать группу. Попробуйте снова.',
        },
    },
    editGroup: {
        title: 'Редактировать группу',
        general: 'Общие',
        groupName: 'Название группы',
        description: 'Описание',
        users: {
            title: 'Назначенные пользователи',
            searchPlaceholder: 'Поиск по имени, фамилии или ID сотрудника...',
            add: 'Добавить',
            remove: 'Удалить {{name}}',
            addedTitle: 'Назначенные пользователи',
            columns: {
                name: 'Имя',
                email: 'Email',
                employeeId: 'ID сотрудника',
            },
            disclaimer:
                'Членство в группе определяет участие в будущих назначениях. Существующие назначения не затрагиваются.',
        },
        save: 'Сохранить',
        discard: 'Отменить',
        confirmModal: {
            title: 'Обновить группу?',
            message:
                'Эта группа используется в назначениях. Изменения состава применяются только к будущим назначениям. Существующие назначения не затрагиваются. Обновления названия группы применяются немедленно.',
            save: 'Сохранить',
            discard: 'Отменить',
        },
        success: {
            updated: 'Группа успешно обновлена',
        },
        errors: {
            nameRequired: 'Название группы обязательно.',
            updateFailed: 'Не удалось обновить группу. Попробуйте снова.',
        },
    },
    createUser: {
        title: 'Создать пользователя',
        subtitle: 'Несколько пользователей',
        upload: {
            dropzone: 'Перетащите CSV-файл сюда или нажмите для выбора',
            selected: 'Выбранный файл:',
            template: 'Скачать шаблон CSV',
            validate: 'Проверить файл',
            fileTypes: 'Только CSV-файлы (.csv)',
            maxRows: 'Максимум 1000 строк за загрузку',
        },
        validation: {
            title: 'Результаты проверки',
            validRow: 'Допустимо',
            summary: {
                total: 'Всего строк',
                valid: 'Допустимых строк',
                invalid: 'Недопустимых строк',
            },
            uploadButton: 'Загрузить пользователей',
            discardButton: 'Отклонить',
            skipNote: 'Будут созданы только допустимые строки. Недопустимые строки будут пропущены.',
        },
        results: {
            title: 'Результаты импорта',
            created: '{{count}} пользователей успешно создано',
            failed: '{{count}} строк не удалось',
            done: 'Готово',
            resetSent: 'Всем созданным пользователям будут отправлены письма для сброса пароля.',
        },
        errors: {
            validationFailed: 'Проверка не удалась. Попробуйте снова.',
            importFailed: 'Импорт не удался. Попробуйте снова.',
        },
        columns: {
            email: 'Эл. почта',
            firstName: 'Имя',
            lastName: 'Фамилия',
            employeeId: 'ID сотрудника',
            language: 'Язык',
            status: 'Статус',
            groups: 'Группы',
            errors: 'Ошибки',
        },
        processing: 'Обработка пользователей, пожалуйста, подождите...',
        singleUser: {
            tabLabel: 'Один пользователь',
            email: 'Эл. почта',
            firstName: 'Имя',
            lastName: 'Фамилия',
            employeeId: 'ID сотрудника',
            password: 'Временный пароль',
            language: 'Язык',
            status: 'Статус',
            active: 'Активен',
            inactive: 'Неактивен',
            english: 'Английский',
            russian: 'Русский',
            lithuanian: 'Литовский',
            userGroups: 'Группы пользователей',
            groupsDisclaimer:
                'Членство в группе определяет участие в будущих назначениях. Существующие назначения не затрагиваются.',
            create: 'Создать',
            discard: 'Отменить',
            createSuccess: 'Пользователь успешно создан',
            errors: {
                emailRequired: 'Эл. почта обязательна',
                emailInvalid: 'Введите корректный адрес эл. почты',
                emailAlreadyExists: 'Пользователь с такой эл. почтой уже существует',
                firstNameRequired: 'Имя обязательно',
                lastNameRequired: 'Фамилия обязательна',
                passwordRequired: 'Пароль обязателен',
                requiredFields: 'Пожалуйста, заполните все обязательные поля',
                createFailed: 'Не удалось создать пользователя. Попробуйте снова.',
            },
        },
        bulkUser: {
            tabLabel: 'Несколько пользователей',
        },
    },
    kpis: {
        measures: {
            km: 'км',
            l100: 'l/100',
            percent: '%',
        },
        eco: {
            ecoScore: {
                name: 'Eко-oценка',
                tooltip: 'Общий балл за эко-вождение рассчитывается на основе указанных ниже показателей',
            },
            fuelConsuption: {
                name: 'Расход топлива',
                tooltip: 'Средний расход топлива за сессию',
            },
            overspeed: {
                name: 'Превышение скорости',
                tooltip: 'Процент расстояния, пройденного с превышением установленного скоростного лимита',
            },
            harshAcceleration: {
                name: 'Резкое ускорение',
                tooltip: 'Процент расстояния, на котором происходило резкое ускорение.',
            },
            coasting: {
                name: 'Движение накатом',
                tooltip: 'Процент возможного расстояния накатом, пройденного c накатом.',
            },
            notOptimalRpm: {
                name: 'Высокие обороты',
                tooltip:
                    'Процент расстояния, пройденного при ускорении выше оптимального (зелёного) диапазона оборотов двигателя.',
            },
            cruiseControl: {
                name: 'Использование круиз-контроля',
                tooltip:
                    'Показывает, какая часть расстояния, где можно было использовать круиз-контроль, фактически была пройдена с включённым круиз-контролем.',
            },
            ccEfficiency: {
                name: 'Эффективность круиз-контроля',
                tooltip:
                    'Оценка рассчитывается на основе штрафных баллов, полученных за неправильное использование круиз-контроля.',
            },
            brakingCountVsStops: {
                name: 'Нажатия тормоза за одну остановку',
                tooltip:
                    'Оценка рассчитывается на основе случаев использования педали тормоза по сравнению с полными остановками.',
            },
            harshBraking: {
                name: 'Pезкое торможение',
                tooltip:
                    'Оценка рассчитывается на основе штрафных баллов, полученных за резкое торможение с использованием педали тормоза.',
            },
            speeding: {
                name: 'Превышение скорости',
                tooltip: 'Процент расстояния, пройденного с превышением установленного скоростного лимита',
            },
        },
    },
    lessonType: {
        '3D': 'Симулятор',
        '360': 'VR-гарнитура',
        PDF: 'PDF',
        Survey: 'Опрос',
        Text: 'Текст',
    },
    datepicker: {
        placeholder: 'MM/DD/YYYY',
        openButton: 'Открыть выбор даты',
        previousMonth: 'Предыдущий месяц',
        nextMonth: 'Следующий месяц',
        clear: 'Очистить',
        ok: 'ОК',
        weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
        months: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
        ],
    },
};
